var _g, _g2, _g3, _g4, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPricesBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1312,
    height: 623,
    viewBox: "0 0 1312 623",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341 210.657L272.5 143L204 210.657L204 264.028L272.5 196.371L341 264.028V210.657ZM341 320.811L272.5 253.169L204 320.811L204 374.169L272.5 306.528L341 374.169V320.811ZM272.5 346.169L340 412.693V465.169L272.5 398.646L205 465.169L205 412.693L272.5 346.169ZM317.5 491.191L272.5 447.028L227.5 491.191L227.5 526.028L272.5 481.865L317.5 526.028V491.191Z",
    fill: "url(#paint0_linear_5059_56408)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M971 210.657L1039.5 143L1108 210.657L1108 264.028L1039.5 196.371L971 264.028V210.657ZM971 320.811L1039.5 253.169L1108 320.811L1108 374.169L1039.5 306.528L971 374.169V320.811ZM1039.5 346.169L972 412.693V465.169L1039.5 398.646L1107 465.169L1107 412.693L1039.5 346.169ZM994.5 491.191L1039.5 447.028L1084.5 491.191L1084.5 526.028L1039.5 481.865L994.5 526.028V491.191Z",
    fill: "url(#paint1_linear_5059_56408)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M537 306.657L468.5 239L400 306.657L400 360.028L468.5 292.371L537 360.028V306.657ZM537 416.811L468.5 349.169L400 416.811L400 470.169L468.5 402.528L537 470.169V416.811ZM468.5 442.169L536 508.693V561.169L468.5 494.646L401 561.169L401 508.693L468.5 442.169ZM513.5 587.191L468.5 543.028L423.5 587.191L423.5 622.028L468.5 577.865L513.5 622.028V587.191Z",
    fill: "url(#paint2_linear_5059_56408)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M775 306.657L843.5 239L912 306.657L912 360.028L843.5 292.371L775 360.028V306.657ZM775 416.811L843.5 349.169L912 416.811L912 470.169L843.5 402.528L775 470.169V416.811ZM843.5 442.169L776 508.693V561.169L843.5 494.646L911 561.169L911 508.693L843.5 442.169ZM798.5 587.191L843.5 543.028L888.5 587.191L888.5 622.028L843.5 577.865L798.5 622.028V587.191Z",
    fill: "url(#paint3_linear_5059_56408)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137 67.6572L68.5 0L0 67.6573L6.38661e-06 121.028L68.5 53.3706L137 121.028V67.6572ZM137 177.811L68.5 110.169L1.5473e-05 177.811L2.24701e-05 231.169L68.5 163.528L137 231.169V177.811ZM68.5 203.169L136 269.693V322.169L68.5 255.646L1.00001 322.169L1 269.693L68.5 203.169ZM113.5 348.191L68.5 304.028L23.5 348.191L23.5 383.028L68.5 338.865L113.5 383.028V348.191Z",
    fill: "url(#paint4_linear_5059_56408)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1175 67.6572L1243.5 0L1312 67.6573L1312 121.028L1243.5 53.3706L1175 121.028V67.6572ZM1175 177.811L1243.5 110.169L1312 177.811L1312 231.169L1243.5 163.528L1175 231.169V177.811ZM1243.5 203.169L1176 269.693V322.169L1243.5 255.646L1311 322.169L1311 269.693L1243.5 203.169ZM1198.5 348.191L1243.5 304.028L1288.5 348.191L1288.5 383.028L1243.5 338.865L1198.5 383.028V348.191Z",
    fill: "url(#paint5_linear_5059_56408)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5059_56408",
    x1: 227.5,
    y1: 169.669,
    x2: 227.5,
    y2: 486.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5059_56408",
    x1: 1084.5,
    y1: 169.669,
    x2: 1084.5,
    y2: 486.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5059_56408",
    x1: 423.5,
    y1: 265.669,
    x2: 423.5,
    y2: 582.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5059_56408",
    x1: 888.5,
    y1: 265.669,
    x2: 888.5,
    y2: 582.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5059_56408",
    x1: 23.5,
    y1: 26.6694,
    x2: 23.5,
    y2: 343.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5059_56408",
    x1: 1288.5,
    y1: 26.6694,
    x2: 1288.5,
    y2: 343.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricesBg);
export default __webpack_public_path__ + "static/media/prices_bg.40eeba2d07fc94101fb7038de8fe1421.svg";
export { ForwardRef as ReactComponent };